import React from "react";
import { Nav, NavLink, NavMenu } from "./NavbarElements";
 
const Navbar = () => {
    return (
        <>
            <Nav>
                <NavMenu>
                    <NavLink to="/feed" activeStyle>
                        Feed
                    </NavLink>
                    <NavLink to="/preferences" activeStyle>
                        Preferences
                    </NavLink>
                </NavMenu>
            </Nav>
        </>
    );
};
 
export default Navbar;